var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.person.photo_small)?_c('a',{staticClass:"tooltip person",attrs:{"data-description":_vm.person.name,"href":`/profile/${_vm.person.id}/`}},[_c('span',{staticClass:"tooltiptext"},[_vm._v(_vm._s(_vm.person.name))]),_vm._v(" "),_c('header',{staticClass:"people-picture-radius",style:(`background-image: url(${_vm.person.photo_small});`)})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }